/* eslint-disable */
/**
 * 本文件由 scripts/gen-registry.mjs 自动生成，请勿手工修改。
 * 从旧工程 269 个页面中提取出 540 个去重后端接口，按模块归集。
 *
 * 用途：
 *   1) 迁移时直接 import 使用，避免手抄 URL 出错
 *   2) 作为接口冻结契约的清单，评审核对后端是否改动
 */

export const API = {
  _common: {
    /** `/appOrgNames` */
    AppOrgNames: '/appOrgNames',
    /** `/chkPwd` */
    ChkPwd: '/chkPwd',
    /** `/cities` */
    Cities: '/cities',
    /** `/filetempupload` */
    Filetempupload: '/filetempupload',
    /** `/fileupload` */
    Fileupload: '/fileupload',
    /** `/getBanksList` */
    GetBanksList: '/getBanksList',
    /** `/getCalRuleList` */
    GetCalRuleList: '/getCalRuleList',
    /** `/getCode` */
    GetCode: '/getCode',
    /** `/getDeviceList` */
    GetDeviceList: '/getDeviceList',
    /** `/getMasterCodeByCodeType` */
    GetMasterCodeByCodeType: '/getMasterCodeByCodeType',
    /** `/getMenu` */
    GetMenu: '/getMenu',
    /** `/getModule` */
    GetModule: '/getModule',
    /** `/getSubMenu` */
    GetSubMenu: '/getSubMenu',
    /** `/guns` */
    Guns: '/guns',
    /** `/login` */
    Login: '/login',
    /** `/manufacturers` */
    Manufacturers: '/manufacturers',
    /** `/pileGroups` */
    PileGroups: '/pileGroups',
    /** `/piles` */
    Piles: '/piles',
    /** `/provinces` */
    Provinces: '/provinces',
    /** `/traders` */
    Traders: '/traders',
  },
  abnormalCause: {
    /** `/abnormalCause/deleteAbnormalCause` */
    DeleteAbnormalCause: '/abnormalCause/deleteAbnormalCause',
    /** `/abnormalCause/queryAbnormalCause` */
    QueryAbnormalCause: '/abnormalCause/queryAbnormalCause',
    /** `/abnormalCause/querylist` */
    Querylist: '/abnormalCause/querylist',
    /** `/abnormalCause/saveAbnormalCause` */
    SaveAbnormalCause: '/abnormalCause/saveAbnormalCause',
  },
  accumulatemanage: {
    /** `/accumulatemanage/deleteAccumulate` */
    DeleteAccumulate: '/accumulatemanage/deleteAccumulate',
    /** `/accumulatemanage/queryAccumulate` */
    QueryAccumulate: '/accumulatemanage/queryAccumulate',
    /** `/accumulatemanage/queryList` */
    QueryList: '/accumulatemanage/queryList',
    /** `/accumulatemanage/saveAccumulate` */
    SaveAccumulate: '/accumulatemanage/saveAccumulate',
  },
  advertmanage: {
    /** `/advertmanage/get` */
    Get: '/advertmanage/get',
    /** `/advertmanage/querylist` */
    Querylist: '/advertmanage/querylist',
    /** `/advertmanage/set` */
    Set: '/advertmanage/set',
  },
  analysisdashboard: {
    /** `/analysisdashboard/accountantStatistics` */
    AccountantStatistics: '/analysisdashboard/accountantStatistics',
    /** `/analysisdashboard/chargingStatistics` */
    ChargingStatistics: '/analysisdashboard/chargingStatistics',
    /** `/analysisdashboard/chargingTimesStatistics` */
    ChargingTimesStatistics: '/analysisdashboard/chargingTimesStatistics',
    /** `/analysisdashboard/orderCountStatistics` */
    OrderCountStatistics: '/analysisdashboard/orderCountStatistics',
    /** `/analysisdashboard/userRegisterStatistics` */
    UserRegisterStatistics: '/analysisdashboard/userRegisterStatistics',
  },
  apiinfomanage: {
    /** `/apiinfomanage/addApi` */
    AddApi: '/apiinfomanage/addApi',
    /** `/apiinfomanage/deleteApi` */
    DeleteApi: '/apiinfomanage/deleteApi',
    /** `/apiinfomanage/queryList` */
    QueryList: '/apiinfomanage/queryList',
    /** `/apiinfomanage/saveApi` */
    SaveApi: '/apiinfomanage/saveApi',
  },
  apilogmanage: {
    /** `/apilogmanage/getAllApi` */
    GetAllApi: '/apilogmanage/getAllApi',
    /** `/apilogmanage/getAllCo` */
    GetAllCo: '/apilogmanage/getAllCo',
    /** `/apilogmanage/getApiCallHis` */
    GetApiCallHis: '/apilogmanage/getApiCallHis',
    /** `/apilogmanage/getApiTransferCount` */
    GetApiTransferCount: '/apilogmanage/getApiTransferCount',
  },
  appid: {
    /** `/appid/addAppId` */
    AddAppId: '/appid/addAppId',
    /** `/appid/delAppId` */
    DelAppId: '/appid/delAppId',
    /** `/appid/editAppId` */
    EditAppId: '/appid/editAppId',
    /** `/appid/getApiLog` */
    GetApiLog: '/appid/getApiLog',
    /** `/appid/getAppGroup` */
    GetAppGroup: '/appid/getAppGroup',
    /** `/appid/getAppIdInfo` */
    GetAppIdInfo: '/appid/getAppIdInfo',
    /** `/appid/querylist` */
    Querylist: '/appid/querylist',
    /** `/appid/updateAppGroup` */
    UpdateAppGroup: '/appid/updateAppGroup',
  },
  appraisemanage: {
    /** `/appraisemanage/getUnReadMessage` */
    GetUnReadMessage: '/appraisemanage/getUnReadMessage',
    /** `/appraisemanage/queryConsultAppraise` */
    QueryConsultAppraise: '/appraisemanage/queryConsultAppraise',
    /** `/appraisemanage/queryList` */
    QueryList: '/appraisemanage/queryList',
    /** `/appraisemanage/saveConsultAppraise` */
    SaveConsultAppraise: '/appraisemanage/saveConsultAppraise',
  },
  appsettingmanage: {
    /** `/appsettingmanage/edit` */
    Edit: '/appsettingmanage/edit',
    /** `/appsettingmanage/get` */
    Get: '/appsettingmanage/get',
    /** `/appsettingmanage/querylist` */
    Querylist: '/appsettingmanage/querylist',
  },
  articlemanager: {
    /** `/articlemanager/deleteArticle` */
    DeleteArticle: '/articlemanager/deleteArticle',
    /** `/articlemanager/deleteGroup` */
    DeleteGroup: '/articlemanager/deleteGroup',
    /** `/articlemanager/queryArticle` */
    QueryArticle: '/articlemanager/queryArticle',
    /** `/articlemanager/queryArticleList` */
    QueryArticleList: '/articlemanager/queryArticleList',
    /** `/articlemanager/queryGroupTreeList` */
    QueryGroupTreeList: '/articlemanager/queryGroupTreeList',
    /** `/articlemanager/saveArticle` */
    SaveArticle: '/articlemanager/saveArticle',
    /** `/articlemanager/saveGroup` */
    SaveGroup: '/articlemanager/saveGroup',
  },
  balancemanager: {
    /** `/balancemanager/query` */
    Query: '/balancemanager/query',
    /** `/balancemanager/queryRefundDetail` */
    QueryRefundDetail: '/balancemanager/queryRefundDetail',
  },
  banksmanager: {
    /** `/banksmanager/delBanksInfo` */
    DelBanksInfo: '/banksmanager/delBanksInfo',
    /** `/banksmanager/queryBanksInfo` */
    QueryBanksInfo: '/banksmanager/queryBanksInfo',
    /** `/banksmanager/queryBanksList` */
    QueryBanksList: '/banksmanager/queryBanksList',
    /** `/banksmanager/saveBanksInfo` */
    SaveBanksInfo: '/banksmanager/saveBanksInfo',
  },
  batchstatistics: {
    /** `/batchstatistics/queryDetailList` */
    QueryDetailList: '/batchstatistics/queryDetailList',
    /** `/batchstatistics/queryList` */
    QueryList: '/batchstatistics/queryList',
  },
  billmanage: {
    /** `/billmanage/query` */
    Query: '/billmanage/query',
    /** `/billmanage/queryDetail` */
    QueryDetail: '/billmanage/queryDetail',
    /** `/billmanage/saveBillPrice` */
    SaveBillPrice: '/billmanage/saveBillPrice',
    /** `/billmanage/updBillDetail` */
    UpdBillDetail: '/billmanage/updBillDetail',
  },
  billtaskmanager: {
    /** `/billtaskmanager/balanceBillTask` */
    BalanceBillTask: '/billtaskmanager/balanceBillTask',
    /** `/billtaskmanager/carryBillTask` */
    CarryBillTask: '/billtaskmanager/carryBillTask',
    /** `/billtaskmanager/confirmBillTask` */
    ConfirmBillTask: '/billtaskmanager/confirmBillTask',
    /** `/billtaskmanager/createBillTask` */
    CreateBillTask: '/billtaskmanager/createBillTask',
    /** `/billtaskmanager/queryDetail` */
    QueryDetail: '/billtaskmanager/queryDetail',
    /** `/billtaskmanager/queryDetailList` */
    QueryDetailList: '/billtaskmanager/queryDetailList',
    /** `/billtaskmanager/queryList` */
    QueryList: '/billtaskmanager/queryList',
  },
  bookingmanage: {
    /** `/bookingmanage/lockOnOff` */
    LockOnOff: '/bookingmanage/lockOnOff',
    /** `/bookingmanage/queryBooking` */
    QueryBooking: '/bookingmanage/queryBooking',
    /** `/bookingmanage/queryBookingTable` */
    QueryBookingTable: '/bookingmanage/queryBookingTable',
    /** `/bookingmanage/queryLog` */
    QueryLog: '/bookingmanage/queryLog',
  },
  calrule: {
    /** `/calrule/delCalruleHtml` */
    DelCalruleHtml: '/calrule/delCalruleHtml',
    /** `/calrule/editInit` */
    EditInit: '/calrule/editInit',
    /** `/calrule/queryCalRuleByName` */
    QueryCalRuleByName: '/calrule/queryCalRuleByName',
    /** `/calrule/queryIsAdmin` */
    QueryIsAdmin: '/calrule/queryIsAdmin',
    /** `/calrule/queryList` */
    QueryList: '/calrule/queryList',
    /** `/calrule/queryTraders` */
    QueryTraders: '/calrule/queryTraders',
    /** `/calrule/saveCalrule` */
    SaveCalrule: '/calrule/saveCalrule',
  },
  carbrand: {
    /** `/carbrand/delCarBrand` */
    DelCarBrand: '/carbrand/delCarBrand',
    /** `/carbrand/edit` */
    Edit: '/carbrand/edit',
    /** `/carbrand/querylist` */
    Querylist: '/carbrand/querylist',
    /** `/carbrand/updCarBrand` */
    UpdCarBrand: '/carbrand/updCarBrand',
  },
  carmanage: {
    /** `/carmanage/editUserCars` */
    EditUserCars: '/carmanage/editUserCars',
    /** `/carmanage/queryCarStatistics` */
    QueryCarStatistics: '/carmanage/queryCarStatistics',
    /** `/carmanage/queryList` */
    QueryList: '/carmanage/queryList',
  },
  common: {
    /** `/common/phone/checkPwdForLoginPerson` */
    PhoneCheckPwdForLoginPerson: '/common/phone/checkPwdForLoginPerson',
    /** `/common/phone/checkVerifyCodeForLoginPerson` */
    PhoneCheckVerifyCodeForLoginPerson: '/common/phone/checkVerifyCodeForLoginPerson',
    /** `/common/phone/sendToLoginPerson` */
    PhoneSendToLoginPerson: '/common/phone/sendToLoginPerson',
  },
  companyaccountmanage: {
    /** `/companyaccountmanage/audit` */
    Audit: '/companyaccountmanage/audit',
    /** `/companyaccountmanage/getCompanyInfo` */
    GetCompanyInfo: '/companyaccountmanage/getCompanyInfo',
    /** `/companyaccountmanage/queryEmployeeList` */
    QueryEmployeeList: '/companyaccountmanage/queryEmployeeList',
    /** `/companyaccountmanage/queryList` */
    QueryList: '/companyaccountmanage/queryList',
    /** `/companyaccountmanage/saveEmployee` */
    SaveEmployee: '/companyaccountmanage/saveEmployee',
  },
  companymanage: {
    /** `/companymanage/audit` */
    Audit: '/companymanage/audit',
    /** `/companymanage/editSecOthersIssued` */
    EditSecOthersIssued: '/companymanage/editSecOthersIssued',
    /** `/companymanage/getAppGroup` */
    GetAppGroup: '/companymanage/getAppGroup',
    /** `/companymanage/getCompanyInfo` */
    GetCompanyInfo: '/companymanage/getCompanyInfo',
    /** `/companymanage/queryList` */
    QueryList: '/companymanage/queryList',
    /** `/companymanage/saveApiSecretkeyEpgroup` */
    SaveApiSecretkeyEpgroup: '/companymanage/saveApiSecretkeyEpgroup',
    /** `/companymanage/saveApiSecretkeyIf` */
    SaveApiSecretkeyIf: '/companymanage/saveApiSecretkeyIf',
    /** `/companymanage/saveApiSecretkeyIfStatus` */
    SaveApiSecretkeyIfStatus: '/companymanage/saveApiSecretkeyIfStatus',
    /** `/companymanage/saveCompanyAllPushStatus` */
    SaveCompanyAllPushStatus: '/companymanage/saveCompanyAllPushStatus',
    /** `/companymanage/saveSecOthersIssued` */
    SaveSecOthersIssued: '/companymanage/saveSecOthersIssued',
  },
  couponmanage: {
    /** `/couponmanage/delCoupon` */
    DelCoupon: '/couponmanage/delCoupon',
    /** `/couponmanage/getCoupon` */
    GetCoupon: '/couponmanage/getCoupon',
    /** `/couponmanage/getNotSelectUserGroup` */
    GetNotSelectUserGroup: '/couponmanage/getNotSelectUserGroup',
    /** `/couponmanage/getSelectUserGroup` */
    GetSelectUserGroup: '/couponmanage/getSelectUserGroup',
    /** `/couponmanage/issueCoupon` */
    IssueCoupon: '/couponmanage/issueCoupon',
    /** `/couponmanage/queryList` */
    QueryList: '/couponmanage/queryList',
    /** `/couponmanage/queryReceivingRecordsList` */
    QueryReceivingRecordsList: '/couponmanage/queryReceivingRecordsList',
    /** `/couponmanage/saveCoupon` */
    SaveCoupon: '/couponmanage/saveCoupon',
  },
  dashboard: {
    /** `/dashboard/allpileNum` */
    AllpileNum: '/dashboard/allpileNum',
    /** `/dashboard/charg` */
    Charg: '/dashboard/charg',
    /** `/dashboard/getAllGroup` */
    GetAllGroup: '/dashboard/getAllGroup',
    /** `/dashboard/getChargeIncomeCount` */
    GetChargeIncomeCount: '/dashboard/getChargeIncomeCount',
    /** `/dashboard/getChargeTerminalTypeCount` */
    GetChargeTerminalTypeCount: '/dashboard/getChargeTerminalTypeCount',
    /** `/dashboard/getChargeTimeCount` */
    GetChargeTimeCount: '/dashboard/getChargeTimeCount',
    /** `/dashboard/getCityGroupPileCount` */
    GetCityGroupPileCount: '/dashboard/getCityGroupPileCount',
    /** `/dashboard/getGroupDevicesInfo` */
    GetGroupDevicesInfo: '/dashboard/getGroupDevicesInfo',
    /** `/dashboard/getGroupInfo` */
    GetGroupInfo: '/dashboard/getGroupInfo',
    /** `/dashboard/getPileDataInfo` */
    GetPileDataInfo: '/dashboard/getPileDataInfo',
    /** `/dashboard/nowOnlinePiles` */
    NowOnlinePiles: '/dashboard/nowOnlinePiles',
    /** `/dashboard/offlineCountList` */
    OfflineCountList: '/dashboard/offlineCountList',
    /** `/dashboard/offlineList` */
    OfflineList: '/dashboard/offlineList',
    /** `/dashboard/queryBreakdown` */
    QueryBreakdown: '/dashboard/queryBreakdown',
    /** `/dashboard/queryGroup` */
    QueryGroup: '/dashboard/queryGroup',
    /** `/dashboard/queryOnlinePiles` */
    QueryOnlinePiles: '/dashboard/queryOnlinePiles',
    /** `/dashboard/queryUsePile` */
    QueryUsePile: '/dashboard/queryUsePile',
    /** `/dashboard/rechargeRate` */
    RechargeRate: '/dashboard/rechargeRate',
    /** `/dashboard/tanPaifang` */
    TanPaifang: '/dashboard/tanPaifang',
    /** `/dashboard/todayBreakdownPiles` */
    TodayBreakdownPiles: '/dashboard/todayBreakdownPiles',
    /** `/dashboard/todayCharging` */
    TodayCharging: '/dashboard/todayCharging',
    /** `/dashboard/todayHappenBreakdownPiles` */
    TodayHappenBreakdownPiles: '/dashboard/todayHappenBreakdownPiles',
    /** `/dashboard/todayOnlinePiles` */
    TodayOnlinePiles: '/dashboard/todayOnlinePiles',
    /** `/dashboard/todayUse` */
    TodayUse: '/dashboard/todayUse',
    /** `/dashboard/todayUserCount` */
    TodayUserCount: '/dashboard/todayUserCount',
    /** `/dashboard/todayrechargeRate` */
    TodayrechargeRate: '/dashboard/todayrechargeRate',
    /** `/dashboard/userCount` */
    UserCount: '/dashboard/userCount',
  },
  devicerepository: {
    /** `/devicerepository/auditDeviceRepos` */
    AuditDeviceRepos: '/devicerepository/auditDeviceRepos',
    /** `/devicerepository/checkDeviceModel` */
    CheckDeviceModel: '/devicerepository/checkDeviceModel',
    /** `/devicerepository/commitDeviceRepos` */
    CommitDeviceRepos: '/devicerepository/commitDeviceRepos',
    /** `/devicerepository/deleteDeviceRepos` */
    DeleteDeviceRepos: '/devicerepository/deleteDeviceRepos',
    /** `/devicerepository/detailDeviceRepos` */
    DetailDeviceRepos: '/devicerepository/detailDeviceRepos',
    /** `/devicerepository/editDeviceRepos` */
    EditDeviceRepos: '/devicerepository/editDeviceRepos',
    /** `/devicerepository/getAccessorys` */
    GetAccessorys: '/devicerepository/getAccessorys',
    /** `/devicerepository/query` */
    Query: '/devicerepository/query',
    /** `/devicerepository/querylist` */
    Querylist: '/devicerepository/querylist',
    /** `/devicerepository/saveDeviceRepos` */
    SaveDeviceRepos: '/devicerepository/saveDeviceRepos',
  },
  devicesmanage: {
    /** `/devicesmanage/delStorageDevice` */
    DelStorageDevice: '/devicesmanage/delStorageDevice',
    /** `/devicesmanage/editStorageDevice` */
    EditStorageDevice: '/devicesmanage/editStorageDevice',
    /** `/devicesmanage/editStoragePhotovoltaic` */
    EditStoragePhotovoltaic: '/devicesmanage/editStoragePhotovoltaic',
    /** `/devicesmanage/getAllNotBindEnergyDevice` */
    GetAllNotBindEnergyDevice: '/devicesmanage/getAllNotBindEnergyDevice',
    /** `/devicesmanage/getAllNotBindGroup` */
    GetAllNotBindGroup: '/devicesmanage/getAllNotBindGroup',
    /** `/devicesmanage/getLastAirConditionerLog` */
    GetLastAirConditionerLog: '/devicesmanage/getLastAirConditionerLog',
    /** `/devicesmanage/getLastEnergyBatteryLog` */
    GetLastEnergyBatteryLog: '/devicesmanage/getLastEnergyBatteryLog',
    /** `/devicesmanage/getLastPcsLog` */
    GetLastPcsLog: '/devicesmanage/getLastPcsLog',
    /** `/devicesmanage/getToDayPhotovoltaicLog` */
    GetToDayPhotovoltaicLog: '/devicesmanage/getToDayPhotovoltaicLog',
    /** `/devicesmanage/getToDayWatthourMeterLog` */
    GetToDayWatthourMeterLog: '/devicesmanage/getToDayWatthourMeterLog',
    /** `/devicesmanage/queryDevice` */
    QueryDevice: '/devicesmanage/queryDevice',
    /** `/devicesmanage/queryDevicesList` */
    QueryDevicesList: '/devicesmanage/queryDevicesList',
  },
  eneryParamsSetting: {
    /** `/eneryParamsSetting/edit` */
    Edit: '/eneryParamsSetting/edit',
    /** `/eneryParamsSetting/save` */
    Save: '/eneryParamsSetting/save',
  },
  factorysetting: {
    /** `/factorysetting/getDevice` */
    GetDevice: '/factorysetting/getDevice',
    /** `/factorysetting/lockPiles` */
    LockPiles: '/factorysetting/lockPiles',
    /** `/factorysetting/query` */
    Query: '/factorysetting/query',
  },
  faultWorkOrderManage: {
    /** `/faultWorkOrderManage/closeFaultOrder` */
    CloseFaultOrder: '/faultWorkOrderManage/closeFaultOrder',
    /** `/faultWorkOrderManage/queryFaultOrder` */
    QueryFaultOrder: '/faultWorkOrderManage/queryFaultOrder',
    /** `/faultWorkOrderManage/queryList` */
    QueryList: '/faultWorkOrderManage/queryList',
    /** `/faultWorkOrderManage/queryOrderLogList` */
    QueryOrderLogList: '/faultWorkOrderManage/queryOrderLogList',
    /** `/faultWorkOrderManage/submit` */
    Submit: '/faultWorkOrderManage/submit',
  },
  faultmanage: {
    /** `/faultmanage/delFaultDetail` */
    DelFaultDetail: '/faultmanage/delFaultDetail',
    /** `/faultmanage/faultRegain` */
    FaultRegain: '/faultmanage/faultRegain',
    /** `/faultmanage/getFaultAllCount` */
    GetFaultAllCount: '/faultmanage/getFaultAllCount',
    /** `/faultmanage/getFaultCount` */
    GetFaultCount: '/faultmanage/getFaultCount',
    /** `/faultmanage/getFaultDetail` */
    GetFaultDetail: '/faultmanage/getFaultDetail',
    /** `/faultmanage/initiatingWorkOrder` */
    InitiatingWorkOrder: '/faultmanage/initiatingWorkOrder',
    /** `/faultmanage/newFault` */
    NewFault: '/faultmanage/newFault',
    /** `/faultmanage/query` */
    Query: '/faultmanage/query',
    /** `/faultmanage/queryChart` */
    QueryChart: '/faultmanage/queryChart',
    /** `/faultmanage/queryDetail` */
    QueryDetail: '/faultmanage/queryDetail',
    /** `/faultmanage/queryLog` */
    QueryLog: '/faultmanage/queryLog',
    /** `/faultmanage/saveFaultDetail` */
    SaveFaultDetail: '/faultmanage/saveFaultDetail',
  },
  faultrulemanage: {
    /** `/faultrulemanage/deleteFaultRule` */
    DeleteFaultRule: '/faultrulemanage/deleteFaultRule',
    /** `/faultrulemanage/queryFaultRule` */
    QueryFaultRule: '/faultrulemanage/queryFaultRule',
    /** `/faultrulemanage/queryList` */
    QueryList: '/faultrulemanage/queryList',
    /** `/faultrulemanage/saveFaultRule` */
    SaveFaultRule: '/faultrulemanage/saveFaultRule',
  },
  iccard: {
    /** `/iccard/checkUser` */
    CheckUser: '/iccard/checkUser',
    /** `/iccard/delCardInfo` */
    DelCardInfo: '/iccard/delCardInfo',
    /** `/iccard/getCardInfo` */
    GetCardInfo: '/iccard/getCardInfo',
    /** `/iccard/inReview` */
    InReview: '/iccard/inReview',
    /** `/iccard/queryApplicationList` */
    QueryApplicationList: '/iccard/queryApplicationList',
    /** `/iccard/queryCpUserList` */
    QueryCpUserList: '/iccard/queryCpUserList',
    /** `/iccard/queryList` */
    QueryList: '/iccard/queryList',
    /** `/iccard/queryLogList` */
    QueryLogList: '/iccard/queryLogList',
    /** `/iccard/queryPilesByParam` */
    QueryPilesByParam: '/iccard/queryPilesByParam',
    /** `/iccard/saveCardInfo` */
    SaveCardInfo: '/iccard/saveCardInfo',
    /** `/iccard/unlockCardInfo` */
    UnlockCardInfo: '/iccard/unlockCardInfo',
  },
  invoicemanage: {
    /** `/invoicemanage/delInvoiceInfo` */
    DelInvoiceInfo: '/invoicemanage/delInvoiceInfo',
    /** `/invoicemanage/getInvoiceInfo` */
    GetInvoiceInfo: '/invoicemanage/getInvoiceInfo',
    /** `/invoicemanage/importTemplatesExcel` */
    ImportTemplatesExcel: '/invoicemanage/importTemplatesExcel',
    /** `/invoicemanage/queryList` */
    QueryList: '/invoicemanage/queryList',
    /** `/invoicemanage/saveInvoiceInfo` */
    SaveInvoiceInfo: '/invoicemanage/saveInvoiceInfo',
  },
  invoicerequestmanage: {
    /** `/invoicerequestmanage/get` */
    Get: '/invoicerequestmanage/get',
    /** `/invoicerequestmanage/queryList` */
    QueryList: '/invoicerequestmanage/queryList',
    /** `/invoicerequestmanage/set` */
    Set: '/invoicerequestmanage/set',
  },
  lock: {
    /** `/lock/boundLockAndGun` */
    BoundLockAndGun: '/lock/boundLockAndGun',
    /** `/lock/deleteGateway` */
    DeleteGateway: '/lock/deleteGateway',
    /** `/lock/deleteLock` */
    DeleteLock: '/lock/deleteLock',
    /** `/lock/queryGatewayList` */
    QueryGatewayList: '/lock/queryGatewayList',
    /** `/lock/queryLockPage` */
    QueryLockPage: '/lock/queryLockPage',
    /** `/lock/setBuzzer` */
    SetBuzzer: '/lock/setBuzzer',
    /** `/lock/setLock` */
    SetLock: '/lock/setLock',
    /** `/lock/syncGateway` */
    SyncGateway: '/lock/syncGateway',
    /** `/lock/syncLock` */
    SyncLock: '/lock/syncLock',
    /** `/lock/unboundLockAndGun` */
    UnboundLockAndGun: '/lock/unboundLockAndGun',
  },
  logmanage: {
    /** `/logmanage/queryOptDetailList` */
    QueryOptDetailList: '/logmanage/queryOptDetailList',
    /** `/logmanage/querylist` */
    Querylist: '/logmanage/querylist',
  },
  logsetting: {
    /** `/logsetting/delLogSetting` */
    DelLogSetting: '/logsetting/delLogSetting',
    /** `/logsetting/editLogSetting` */
    EditLogSetting: '/logsetting/editLogSetting',
    /** `/logsetting/getBusinessName` */
    GetBusinessName: '/logsetting/getBusinessName',
    /** `/logsetting/getMCodeType` */
    GetMCodeType: '/logsetting/getMCodeType',
    /** `/logsetting/getTableColumnList` */
    GetTableColumnList: '/logsetting/getTableColumnList',
    /** `/logsetting/getTableList` */
    GetTableList: '/logsetting/getTableList',
    /** `/logsetting/querylist` */
    Querylist: '/logsetting/querylist',
    /** `/logsetting/saveLogSetting` */
    SaveLogSetting: '/logsetting/saveLogSetting',
  },
  manufacturer: {
    /** `/manufacturer/delMfr` */
    DelMfr: '/manufacturer/delMfr',
    /** `/manufacturer/editMfr` */
    EditMfr: '/manufacturer/editMfr',
    /** `/manufacturer/generateKey` */
    GenerateKey: '/manufacturer/generateKey',
    /** `/manufacturer/queryList` */
    QueryList: '/manufacturer/queryList',
    /** `/manufacturer/saveMfr` */
    SaveMfr: '/manufacturer/saveMfr',
  },
  masterCode: {
    /** `/masterCode/saveMasterCode` */
    SaveMasterCode: '/masterCode/saveMasterCode',
    /** `/masterCode/selectMasterCode` */
    SelectMasterCode: '/masterCode/selectMasterCode',
    /** `/masterCode/updateBatchSort` */
    UpdateBatchSort: '/masterCode/updateBatchSort',
    /** `/masterCode/updateCodeType` */
    UpdateCodeType: '/masterCode/updateCodeType',
  },
  menumanage: {
    /** `/menumanage/delMenu` */
    DelMenu: '/menumanage/delMenu',
    /** `/menumanage/editMenu` */
    EditMenu: '/menumanage/editMenu',
    /** `/menumanage/getPreviousMenu` */
    GetPreviousMenu: '/menumanage/getPreviousMenu',
    /** `/menumanage/querylist` */
    Querylist: '/menumanage/querylist',
    /** `/menumanage/saveMenu` */
    SaveMenu: '/menumanage/saveMenu',
  },
  messagemanage: {
    /** `/messagemanage/editMessage` */
    EditMessage: '/messagemanage/editMessage',
    /** `/messagemanage/getNotSelectUserGroup` */
    GetNotSelectUserGroup: '/messagemanage/getNotSelectUserGroup',
    /** `/messagemanage/getSelectUserGroup` */
    GetSelectUserGroup: '/messagemanage/getSelectUserGroup',
    /** `/messagemanage/getUnReadCount` */
    GetUnReadCount: '/messagemanage/getUnReadCount',
    /** `/messagemanage/queryMessageUserMap` */
    QueryMessageUserMap: '/messagemanage/queryMessageUserMap',
    /** `/messagemanage/querylist` */
    Querylist: '/messagemanage/querylist',
    /** `/messagemanage/saveMessage` */
    SaveMessage: '/messagemanage/saveMessage',
    /** `/messagemanage/sendMessage` */
    SendMessage: '/messagemanage/sendMessage',
  },
  messagetemplatemanage: {
    /** `/messagetemplatemanage/get` */
    Get: '/messagetemplatemanage/get',
    /** `/messagetemplatemanage/querylist` */
    Querylist: '/messagetemplatemanage/querylist',
    /** `/messagetemplatemanage/set` */
    Set: '/messagetemplatemanage/set',
  },
  modulemanage: {
    /** `/modulemanage/delModule` */
    DelModule: '/modulemanage/delModule',
    /** `/modulemanage/editModule` */
    EditModule: '/modulemanage/editModule',
    /** `/modulemanage/queryList` */
    QueryList: '/modulemanage/queryList',
    /** `/modulemanage/saveModule` */
    SaveModule: '/modulemanage/saveModule',
  },
  monitorboard: {
    /** `/monitorboard/queryNvrList` */
    QueryNvrList: '/monitorboard/queryNvrList',
    /** `/monitorboard/querySites` */
    QuerySites: '/monitorboard/querySites',
    /** `/monitorboard/updateCameraList` */
    UpdateCameraList: '/monitorboard/updateCameraList',
    /** `/monitorboard/updateNvrInfo` */
    UpdateNvrInfo: '/monitorboard/updateNvrInfo',
  },
  monitordevicemanage: {
    /** `/monitordevicemanage/query` */
    Query: '/monitordevicemanage/query',
    /** `/monitordevicemanage/queryList` */
    QueryList: '/monitordevicemanage/queryList',
    /** `/monitordevicemanage/queryType` */
    QueryType: '/monitordevicemanage/queryType',
    /** `/monitordevicemanage/set` */
    Set: '/monitordevicemanage/set',
    /** `/monitordevicemanage/setType` */
    SetType: '/monitordevicemanage/setType',
  },
  monthBillManager: {
    /** `/monthBillManager/queryDayBill` */
    QueryDayBill: '/monthBillManager/queryDayBill',
    /** `/monthBillManager/queryNothingUserList` */
    QueryNothingUserList: '/monthBillManager/queryNothingUserList',
    /** `/monthBillManager/queryUserDayBill` */
    QueryUserDayBill: '/monthBillManager/queryUserDayBill',
    /** `/monthBillManager/queryUserList` */
    QueryUserList: '/monthBillManager/queryUserList',
    /** `/monthBillManager/saveUserList` */
    SaveUserList: '/monthBillManager/saveUserList',
  },
  operationsanalysis: {
    /** `/operationsanalysis/queryChangeTimeChart` */
    QueryChangeTimeChart: '/operationsanalysis/queryChangeTimeChart',
    /** `/operationsanalysis/queryChargingSuccessRate` */
    QueryChargingSuccessRate: '/operationsanalysis/queryChargingSuccessRate',
    /** `/operationsanalysis/queryCpVoltageWarningChart` */
    QueryCpVoltageWarningChart: '/operationsanalysis/queryCpVoltageWarningChart',
    /** `/operationsanalysis/queryCurrentWarningChart` */
    QueryCurrentWarningChart: '/operationsanalysis/queryCurrentWarningChart',
    /** `/operationsanalysis/queryFaultTypeChart` */
    QueryFaultTypeChart: '/operationsanalysis/queryFaultTypeChart',
    /** `/operationsanalysis/queryOrderTableList` */
    QueryOrderTableList: '/operationsanalysis/queryOrderTableList',
    /** `/operationsanalysis/queryRecordMsgZeroChart` */
    QueryRecordMsgZeroChart: '/operationsanalysis/queryRecordMsgZeroChart',
    /** `/operationsanalysis/queryUserList` */
    QueryUserList: '/operationsanalysis/queryUserList',
  },
  ordermanage: {
    /** `/ordermanage/allSiteIncomeCharging` */
    AllSiteIncomeCharging: '/ordermanage/allSiteIncomeCharging',
    /** `/ordermanage/allSiteOrderCharging` */
    AllSiteOrderCharging: '/ordermanage/allSiteOrderCharging',
    /** `/ordermanage/allSiteOrderCount` */
    AllSiteOrderCount: '/ordermanage/allSiteOrderCount',
    /** `/ordermanage/chartByAc` */
    ChartByAc: '/ordermanage/chartByAc',
    /** `/ordermanage/chartByDc` */
    ChartByDc: '/ordermanage/chartByDc',
    /** `/ordermanage/getBatteryByOrderId` */
    GetBatteryByOrderId: '/ordermanage/getBatteryByOrderId',
    /** `/ordermanage/getBatteryDetectByOrderId` */
    GetBatteryDetectByOrderId: '/ordermanage/getBatteryDetectByOrderId',
    /** `/ordermanage/getBatteryDetectDetailByOrderId` */
    GetBatteryDetectDetailByOrderId: '/ordermanage/getBatteryDetectDetailByOrderId',
    /** `/ordermanage/getOrderTotalPrice` */
    GetOrderTotalPrice: '/ordermanage/getOrderTotalPrice',
    /** `/ordermanage/invoiceFinsh` */
    InvoiceFinsh: '/ordermanage/invoiceFinsh',
    /** `/ordermanage/orderCharging` */
    OrderCharging: '/ordermanage/orderCharging',
    /** `/ordermanage/orderChargingChart` */
    OrderChargingChart: '/ordermanage/orderChargingChart',
    /** `/ordermanage/orderCount` */
    OrderCount: '/ordermanage/orderCount',
    /** `/ordermanage/orderCountChart` */
    OrderCountChart: '/ordermanage/orderCountChart',
    /** `/ordermanage/orderIncome` */
    OrderIncome: '/ordermanage/orderIncome',
    /** `/ordermanage/orderIncomeChart` */
    OrderIncomeChart: '/ordermanage/orderIncomeChart',
    /** `/ordermanage/ordercharginglist` */
    Ordercharginglist: '/ordermanage/ordercharginglist',
    /** `/ordermanage/ordercountlist` */
    Ordercountlist: '/ordermanage/ordercountlist',
    /** `/ordermanage/orderincomelist` */
    Orderincomelist: '/ordermanage/orderincomelist',
    /** `/ordermanage/pileGroups` */
    PileGroups: '/ordermanage/pileGroups',
    /** `/ordermanage/queryAmpereLimitStatictis` */
    QueryAmpereLimitStatictis: '/ordermanage/queryAmpereLimitStatictis',
    /** `/ordermanage/queryCalRuleDetail` */
    QueryCalRuleDetail: '/ordermanage/queryCalRuleDetail',
    /** `/ordermanage/queryInvoice` */
    QueryInvoice: '/ordermanage/queryInvoice',
    /** `/ordermanage/queryOrder` */
    QueryOrder: '/ordermanage/queryOrder',
    /** `/ordermanage/queryOrderDetail` */
    QueryOrderDetail: '/ordermanage/queryOrderDetail',
    /** `/ordermanage/queryOrderLog` */
    QueryOrderLog: '/ordermanage/queryOrderLog',
    /** `/ordermanage/queryOrderTableList` */
    QueryOrderTableList: '/ordermanage/queryOrderTableList',
    /** `/ordermanage/queryOrderdetailTableList` */
    QueryOrderdetailTableList: '/ordermanage/queryOrderdetailTableList',
    /** `/ordermanage/queryOutOrderTableList` */
    QueryOutOrderTableList: '/ordermanage/queryOutOrderTableList',
    /** `/ordermanage/sendDisputeOrder` */
    SendDisputeOrder: '/ordermanage/sendDisputeOrder',
    /** `/ordermanage/setOrderTotalPrice` */
    SetOrderTotalPrice: '/ordermanage/setOrderTotalPrice',
  },
  paramsSetting: {
    /** `/paramsSetting/edit` */
    Edit: '/paramsSetting/edit',
    /** `/paramsSetting/query` */
    Query: '/paramsSetting/query',
    /** `/paramsSetting/save` */
    Save: '/paramsSetting/save',
  },
  parkingmanage: {
    /** `/parkingmanage/queryList` */
    QueryList: '/parkingmanage/queryList',
  },
  pilelist: {
    /** `/pilelist/getMonitoringData` */
    GetMonitoringData: '/pilelist/getMonitoringData',
    /** `/pilelist/getOrderDetail` */
    GetOrderDetail: '/pilelist/getOrderDetail',
    /** `/pilelist/getPileGunDetail` */
    GetPileGunDetail: '/pilelist/getPileGunDetail',
    /** `/pilelist/getPileGunFultFun` */
    GetPileGunFultFun: '/pilelist/getPileGunFultFun',
    /** `/pilelist/getPileGunNewFault` */
    GetPileGunNewFault: '/pilelist/getPileGunNewFault',
    /** `/pilelist/getPileStatusData` */
    GetPileStatusData: '/pilelist/getPileStatusData',
    /** `/pilelist/getSOCDetail` */
    GetSOCDetail: '/pilelist/getSOCDetail',
    /** `/pilelist/getSiteStatusData` */
    GetSiteStatusData: '/pilelist/getSiteStatusData',
    /** `/pilelist/query` */
    Query: '/pilelist/query',
    /** `/pilelist/savePileGunData` */
    SavePileGunData: '/pilelist/savePileGunData',
  },
  pilemeterspower: {
    /** `/pilemeterspower/queryDetailList` */
    QueryDetailList: '/pilemeterspower/queryDetailList',
    /** `/pilemeterspower/querylist` */
    Querylist: '/pilemeterspower/querylist',
  },
  pilesetting: {
    /** `/pilesetting/importTemplate` */
    ImportTemplate: '/pilesetting/importTemplate',
    /** `/pilesetting/queryPile` */
    QueryPile: '/pilesetting/queryPile',
  },
  pilesync: {
    /** `/pilesync/calRuleDetail` */
    CalRuleDetail: '/pilesync/calRuleDetail',
    /** `/pilesync/changeTreader` */
    ChangeTreader: '/pilesync/changeTreader',
    /** `/pilesync/pileOptLog` */
    PileOptLog: '/pilesync/pileOptLog',
    /** `/pilesync/prePgSet` */
    PrePgSet: '/pilesync/prePgSet',
    /** `/pilesync/prePgSetSave` */
    PrePgSetSave: '/pilesync/prePgSetSave',
    /** `/pilesync/precalSet` */
    PrecalSet: '/pilesync/precalSet',
    /** `/pilesync/precalSetSave` */
    PrecalSetSave: '/pilesync/precalSetSave',
    /** `/pilesync/queryPile` */
    QueryPile: '/pilesync/queryPile',
    /** `/pilesync/queryProgramSycnLog` */
    QueryProgramSycnLog: '/pilesync/queryProgramSycnLog',
    /** `/pilesync/removeDoSynchroPg` */
    RemoveDoSynchroPg: '/pilesync/removeDoSynchroPg',
    /** `/pilesync/syncDtu` */
    SyncDtu: '/pilesync/syncDtu',
    /** `/pilesync/syncIP` */
    SyncIP: '/pilesync/syncIP',
    /** `/pilesync/syncTrader` */
    SyncTrader: '/pilesync/syncTrader',
    /** `/pilesync/treaderSetSave` */
    TreaderSetSave: '/pilesync/treaderSetSave',
  },
  programmanage: {
    /** `/programmanage/delAccessory` */
    DelAccessory: '/programmanage/delAccessory',
    /** `/programmanage/delProgram` */
    DelProgram: '/programmanage/delProgram',
    /** `/programmanage/edit` */
    Edit: '/programmanage/edit',
    /** `/programmanage/getAccessorys` */
    GetAccessorys: '/programmanage/getAccessorys',
    /** `/programmanage/query` */
    Query: '/programmanage/query',
    /** `/programmanage/querylist` */
    Querylist: '/programmanage/querylist',
    /** `/programmanage/save` */
    Save: '/programmanage/save',
  },
  ratePlan: {
    /** `/ratePlan/findRatePlan` */
    FindRatePlan: '/ratePlan/findRatePlan',
  },
  reportfaultmanage: {
    /** `/reportfaultmanage/queryReportFault` */
    QueryReportFault: '/reportfaultmanage/queryReportFault',
    /** `/reportfaultmanage/querylist` */
    Querylist: '/reportfaultmanage/querylist',
    /** `/reportfaultmanage/saveReportFault` */
    SaveReportFault: '/reportfaultmanage/saveReportFault',
  },
  resourcemanage: {
    /** `/resourcemanage/addResource` */
    AddResource: '/resourcemanage/addResource',
    /** `/resourcemanage/addResourceSave` */
    AddResourceSave: '/resourcemanage/addResourceSave',
    /** `/resourcemanage/delRes` */
    DelRes: '/resourcemanage/delRes',
    /** `/resourcemanage/queryList` */
    QueryList: '/resourcemanage/queryList',
  },
  rolemanage: {
    /** `/rolemanage/delRole` */
    DelRole: '/rolemanage/delRole',
    /** `/rolemanage/editRole` */
    EditRole: '/rolemanage/editRole',
    /** `/rolemanage/getNotSelectUserRoleList` */
    GetNotSelectUserRoleList: '/rolemanage/getNotSelectUserRoleList',
    /** `/rolemanage/getSelectUserRoleList` */
    GetSelectUserRoleList: '/rolemanage/getSelectUserRoleList',
    /** `/rolemanage/queryResourceAndStatus` */
    QueryResourceAndStatus: '/rolemanage/queryResourceAndStatus',
    /** `/rolemanage/querylist` */
    Querylist: '/rolemanage/querylist',
    /** `/rolemanage/saveResource` */
    SaveResource: '/rolemanage/saveResource',
    /** `/rolemanage/saveRole` */
    SaveRole: '/rolemanage/saveRole',
  },
  secretKeyManager: {
    /** `/secretKeyManager/getUserType` */
    GetUserType: '/secretKeyManager/getUserType',
    /** `/secretKeyManager/listByType` */
    ListByType: '/secretKeyManager/listByType',
    /** `/secretKeyManager/reload` */
    Reload: '/secretKeyManager/reload',
    /** `/secretKeyManager/update` */
    Update: '/secretKeyManager/update',
  },
  shareprofitmanage: {
    /** `/shareprofitmanage/editShareProfitRule` */
    EditShareProfitRule: '/shareprofitmanage/editShareProfitRule',
    /** `/shareprofitmanage/queryList` */
    QueryList: '/shareprofitmanage/queryList',
    /** `/shareprofitmanage/saveShareProfitRule` */
    SaveShareProfitRule: '/shareprofitmanage/saveShareProfitRule',
  },
  sitemanage: {
    /** `/sitemanage/application` */
    Application: '/sitemanage/application',
    /** `/sitemanage/barCodeInit` */
    BarCodeInit: '/sitemanage/barCodeInit',
    /** `/sitemanage/batteryChart` */
    BatteryChart: '/sitemanage/batteryChart',
    /** `/sitemanage/boundLockAndGun` */
    BoundLockAndGun: '/sitemanage/boundLockAndGun',
    /** `/sitemanage/changeStatus` */
    ChangeStatus: '/sitemanage/changeStatus',
    /** `/sitemanage/chargingUser` */
    ChargingUser: '/sitemanage/chargingUser',
    /** `/sitemanage/chargingtablelist` */
    Chargingtablelist: '/sitemanage/chargingtablelist',
    /** `/sitemanage/delMacAdd` */
    DelMacAdd: '/sitemanage/delMacAdd',
    /** `/sitemanage/delPiles` */
    DelPiles: '/sitemanage/delPiles',
    /** `/sitemanage/delSite` */
    DelSite: '/sitemanage/delSite',
    /** `/sitemanage/deleteDeviceGunMapping` */
    DeleteDeviceGunMapping: '/sitemanage/deleteDeviceGunMapping',
    /** `/sitemanage/editBase` */
    EditBase: '/sitemanage/editBase',
    /** `/sitemanage/editGun` */
    EditGun: '/sitemanage/editGun',
    /** `/sitemanage/editPile` */
    EditPile: '/sitemanage/editPile',
    /** `/sitemanage/editPiles` */
    EditPiles: '/sitemanage/editPiles',
    /** `/sitemanage/energyBatteryList` */
    EnergyBatteryList: '/sitemanage/energyBatteryList',
    /** `/sitemanage/energyChange` */
    EnergyChange: '/sitemanage/energyChange',
    /** `/sitemanage/getBrands` */
    GetBrands: '/sitemanage/getBrands',
    /** `/sitemanage/getChargeBySite` */
    GetChargeBySite: '/sitemanage/getChargeBySite',
    /** `/sitemanage/getCo2BySite` */
    GetCo2BySite: '/sitemanage/getCo2BySite',
    /** `/sitemanage/getDetectCountBySite` */
    GetDetectCountBySite: '/sitemanage/getDetectCountBySite',
    /** `/sitemanage/getGroupPhotos` */
    GetGroupPhotos: '/sitemanage/getGroupPhotos',
    /** `/sitemanage/getLockList` */
    GetLockList: '/sitemanage/getLockList',
    /** `/sitemanage/getPayType` */
    GetPayType: '/sitemanage/getPayType',
    /** `/sitemanage/getPileBySite` */
    GetPileBySite: '/sitemanage/getPileBySite',
    /** `/sitemanage/getPrice` */
    GetPrice: '/sitemanage/getPrice',
    /** `/sitemanage/getRouterInfo` */
    GetRouterInfo: '/sitemanage/getRouterInfo',
    /** `/sitemanage/heartJsonData` */
    HeartJsonData: '/sitemanage/heartJsonData',
    /** `/sitemanage/inReview` */
    InReview: '/sitemanage/inReview',
    /** `/sitemanage/lookBase` */
    LookBase: '/sitemanage/lookBase',
    /** `/sitemanage/normal` */
    Normal: '/sitemanage/normal',
    /** `/sitemanage/offlineQueryLog` */
    OfflineQueryLog: '/sitemanage/offlineQueryLog',
    /** `/sitemanage/offlineSynchro` */
    OfflineSynchro: '/sitemanage/offlineSynchro',
    /** `/sitemanage/powerChart` */
    PowerChart: '/sitemanage/powerChart',
    /** `/sitemanage/query` */
    Query: '/sitemanage/query',
    /** `/sitemanage/queryAnprDeviceList` */
    QueryAnprDeviceList: '/sitemanage/queryAnprDeviceList',
    /** `/sitemanage/queryChargLog` */
    QueryChargLog: '/sitemanage/queryChargLog',
    /** `/sitemanage/queryChargingUser` */
    QueryChargingUser: '/sitemanage/queryChargingUser',
    /** `/sitemanage/queryCodeHash` */
    QueryCodeHash: '/sitemanage/queryCodeHash',
    /** `/sitemanage/queryCpVoltageStatistics` */
    QueryCpVoltageStatistics: '/sitemanage/queryCpVoltageStatistics',
    /** `/sitemanage/queryDateTimeLog` */
    QueryDateTimeLog: '/sitemanage/queryDateTimeLog',
    /** `/sitemanage/queryEnergyDevices` */
    QueryEnergyDevices: '/sitemanage/queryEnergyDevices',
    /** `/sitemanage/queryLockInfo` */
    QueryLockInfo: '/sitemanage/queryLockInfo',
    /** `/sitemanage/queryLockPage` */
    QueryLockPage: '/sitemanage/queryLockPage',
    /** `/sitemanage/queryMacAdd` */
    QueryMacAdd: '/sitemanage/queryMacAdd',
    /** `/sitemanage/queryOnlineTime` */
    QueryOnlineTime: '/sitemanage/queryOnlineTime',
    /** `/sitemanage/queryPhotovoltaicDataList` */
    QueryPhotovoltaicDataList: '/sitemanage/queryPhotovoltaicDataList',
    /** `/sitemanage/queryPhotovoltaicInfo` */
    QueryPhotovoltaicInfo: '/sitemanage/queryPhotovoltaicInfo',
    /** `/sitemanage/queryPileGuns` */
    QueryPileGuns: '/sitemanage/queryPileGuns',
    /** `/sitemanage/queryPiles` */
    QueryPiles: '/sitemanage/queryPiles',
    /** `/sitemanage/queryPowerDataList` */
    QueryPowerDataList: '/sitemanage/queryPowerDataList',
    /** `/sitemanage/querySiteCharging` */
    QuerySiteCharging: '/sitemanage/querySiteCharging',
    /** `/sitemanage/querySiteChargingNum` */
    QuerySiteChargingNum: '/sitemanage/querySiteChargingNum',
    /** `/sitemanage/queryStatistics` */
    QueryStatistics: '/sitemanage/queryStatistics',
    /** `/sitemanage/queryUserLog` */
    QueryUserLog: '/sitemanage/queryUserLog',
    /** `/sitemanage/querylist` */
    Querylist: '/sitemanage/querylist',
    /** `/sitemanage/saveAnprDevice` */
    SaveAnprDevice: '/sitemanage/saveAnprDevice',
    /** `/sitemanage/saveBase` */
    SaveBase: '/sitemanage/saveBase',
    /** `/sitemanage/saveGroupId` */
    SaveGroupId: '/sitemanage/saveGroupId',
    /** `/sitemanage/saveGroupShareprofit` */
    SaveGroupShareprofit: '/sitemanage/saveGroupShareprofit',
    /** `/sitemanage/saveGun` */
    SaveGun: '/sitemanage/saveGun',
    /** `/sitemanage/savePile` */
    SavePile: '/sitemanage/savePile',
    /** `/sitemanage/savePiles` */
    SavePiles: '/sitemanage/savePiles',
    /** `/sitemanage/siteCharging` */
    SiteCharging: '/sitemanage/siteCharging',
    /** `/sitemanage/siteChargingNum` */
    SiteChargingNum: '/sitemanage/siteChargingNum',
    /** `/sitemanage/tablelist` */
    Tablelist: '/sitemanage/tablelist',
    /** `/sitemanage/unboundLockAndGun` */
    UnboundLockAndGun: '/sitemanage/unboundLockAndGun',
    /** `/sitemanage/updatePileMacAdd` */
    UpdatePileMacAdd: '/sitemanage/updatePileMacAdd',
    /** `/sitemanage/usertablelist` */
    Usertablelist: '/sitemanage/usertablelist',
  },
  standalone: {
    /** `/standalone/addGenerateKey` */
    AddGenerateKey: '/standalone/addGenerateKey',
    /** `/standalone/getDetailLicenseInfo` */
    GetDetailLicenseInfo: '/standalone/getDetailLicenseInfo',
    /** `/standalone/getProgramDetailInfo` */
    GetProgramDetailInfo: '/standalone/getProgramDetailInfo',
    /** `/standalone/parseKey` */
    ParseKey: '/standalone/parseKey',
    /** `/standalone/queryList` */
    QueryList: '/standalone/queryList',
    /** `/standalone/queryProgramList` */
    QueryProgramList: '/standalone/queryProgramList',
    /** `/standalone/saveProgramInfo` */
    SaveProgramInfo: '/standalone/saveProgramInfo',
    /** `/standalone/sendEmail` */
    SendEmail: '/standalone/sendEmail',
  },
  systemsetting: {
    /** `/systemsetting/del` */
    Del: '/systemsetting/del',
    /** `/systemsetting/edit` */
    Edit: '/systemsetting/edit',
    /** `/systemsetting/query` */
    Query: '/systemsetting/query',
    /** `/systemsetting/queryshipping` */
    Queryshipping: '/systemsetting/queryshipping',
    /** `/systemsetting/save` */
    Save: '/systemsetting/save',
  },
  taskmanage: {
    /** `/taskmanage/queryList` */
    QueryList: '/taskmanage/queryList',
  },
  thirdpartyuser: {
    /** `/thirdpartyuser/delTrader` */
    DelTrader: '/thirdpartyuser/delTrader',
    /** `/thirdpartyuser/editTrader` */
    EditTrader: '/thirdpartyuser/editTrader',
    /** `/thirdpartyuser/queryList` */
    QueryList: '/thirdpartyuser/queryList',
    /** `/thirdpartyuser/saveTrader` */
    SaveTrader: '/thirdpartyuser/saveTrader',
  },
  traderuser: {
    /** `/traderuser/addTraderUserManage` */
    AddTraderUserManage: '/traderuser/addTraderUserManage',
    /** `/traderuser/auditTraderuser` */
    AuditTraderuser: '/traderuser/auditTraderuser',
    /** `/traderuser/delTrader` */
    DelTrader: '/traderuser/delTrader',
    /** `/traderuser/delTraderUser` */
    DelTraderUser: '/traderuser/delTraderUser',
    /** `/traderuser/editTrader` */
    EditTrader: '/traderuser/editTrader',
    /** `/traderuser/queryCanSetTraderManageUser` */
    QueryCanSetTraderManageUser: '/traderuser/queryCanSetTraderManageUser',
    /** `/traderuser/queryList` */
    QueryList: '/traderuser/queryList',
    /** `/traderuser/queryTraderUserManage` */
    QueryTraderUserManage: '/traderuser/queryTraderUserManage',
    /** `/traderuser/saveTrader` */
    SaveTrader: '/traderuser/saveTrader',
    /** `/traderuser/saveTraderShareprofit` */
    SaveTraderShareprofit: '/traderuser/saveTraderShareprofit',
    /** `/traderuser/saveTraderUserManage` */
    SaveTraderUserManage: '/traderuser/saveTraderUserManage',
    /** `/traderuser/updateLock` */
    UpdateLock: '/traderuser/updateLock',
    /** `/traderuser/updateUserWxPushStatus` */
    UpdateUserWxPushStatus: '/traderuser/updateUserWxPushStatus',
  },
  transfermanage: {
    /** `/transfermanage/queryDetail` */
    QueryDetail: '/transfermanage/queryDetail',
    /** `/transfermanage/queryList` */
    QueryList: '/transfermanage/queryList',
  },
  transferstatistics: {
    /** `/transferstatistics/queryMerchantBillStatistics` */
    QueryMerchantBillStatistics: '/transferstatistics/queryMerchantBillStatistics',
    /** `/transferstatistics/queryMerchantBillTable` */
    QueryMerchantBillTable: '/transferstatistics/queryMerchantBillTable',
    /** `/transferstatistics/queryOrderCountStatistics` */
    QueryOrderCountStatistics: '/transferstatistics/queryOrderCountStatistics',
    /** `/transferstatistics/queryProfitStatistics` */
    QueryProfitStatistics: '/transferstatistics/queryProfitStatistics',
    /** `/transferstatistics/queryTransferTable` */
    QueryTransferTable: '/transferstatistics/queryTransferTable',
  },
  unicom: {
    /** `/unicom/changeDefaultUser` */
    ChangeDefaultUser: '/unicom/changeDefaultUser',
    /** `/unicom/changeRecord` */
    ChangeRecord: '/unicom/changeRecord',
    /** `/unicom/delDevice` */
    DelDevice: '/unicom/delDevice',
    /** `/unicom/delUser` */
    DelUser: '/unicom/delUser',
    /** `/unicom/findById` */
    FindById: '/unicom/findById',
    /** `/unicom/getApiKey` */
    GetApiKey: '/unicom/getApiKey',
    /** `/unicom/getUpToDateTime` */
    GetUpToDateTime: '/unicom/getUpToDateTime',
    /** `/unicom/historyUsage` */
    HistoryUsage: '/unicom/historyUsage',
    /** `/unicom/locationHistory` */
    LocationHistory: '/unicom/locationHistory',
    /** `/unicom/queryUnicomDeviceList` */
    QueryUnicomDeviceList: '/unicom/queryUnicomDeviceList',
    /** `/unicom/queryUnicomUser` */
    QueryUnicomUser: '/unicom/queryUnicomUser',
    /** `/unicom/queryUnicomUserList` */
    QueryUnicomUserList: '/unicom/queryUnicomUserList',
    /** `/unicom/resetApiKey` */
    ResetApiKey: '/unicom/resetApiKey',
    /** `/unicom/saveUnicomDevice` */
    SaveUnicomDevice: '/unicom/saveUnicomDevice',
    /** `/unicom/sessionInfo` */
    SessionInfo: '/unicom/sessionInfo',
    /** `/unicom/syncUnicomDevices` */
    SyncUnicomDevices: '/unicom/syncUnicomDevices',
    /** `/unicom/syncUnicomUser` */
    SyncUnicomUser: '/unicom/syncUnicomUser',
    /** `/unicom/usageInZone` */
    UsageInZone: '/unicom/usageInZone',
  },
  usermanage: {
    /** `/usermanage/checkMobile` */
    CheckMobile: '/usermanage/checkMobile',
    /** `/usermanage/clearChargeCnt` */
    ClearChargeCnt: '/usermanage/clearChargeCnt',
    /** `/usermanage/delUser` */
    DelUser: '/usermanage/delUser',
    /** `/usermanage/editUser` */
    EditUser: '/usermanage/editUser',
    /** `/usermanage/getNotSelectUserRoleList` */
    GetNotSelectUserRoleList: '/usermanage/getNotSelectUserRoleList',
    /** `/usermanage/getSelectUserRoleList` */
    GetSelectUserRoleList: '/usermanage/getSelectUserRoleList',
    /** `/usermanage/getUserCars` */
    GetUserCars: '/usermanage/getUserCars',
    /** `/usermanage/queryAccumulateList` */
    QueryAccumulateList: '/usermanage/queryAccumulateList',
    /** `/usermanage/queryList` */
    QueryList: '/usermanage/queryList',
    /** `/usermanage/queryOperatingRecord` */
    QueryOperatingRecord: '/usermanage/queryOperatingRecord',
    /** `/usermanage/recharge` */
    Recharge: '/usermanage/recharge',
    /** `/usermanage/saveLockOptFlag` */
    SaveLockOptFlag: '/usermanage/saveLockOptFlag',
    /** `/usermanage/saveNewPwd` */
    SaveNewPwd: '/usermanage/saveNewPwd',
    /** `/usermanage/saveRecharge` */
    SaveRecharge: '/usermanage/saveRecharge',
    /** `/usermanage/saveUser` */
    SaveUser: '/usermanage/saveUser',
    /** `/usermanage/saveUserRole` */
    SaveUserRole: '/usermanage/saveUserRole',
    /** `/usermanage/unlockUser` */
    UnlockUser: '/usermanage/unlockUser',
  },
  whiteblack: {
    /** `/whiteblack/addWhiteBlackInfo` */
    AddWhiteBlackInfo: '/whiteblack/addWhiteBlackInfo',
    /** `/whiteblack/delWhiteBlackInfo` */
    DelWhiteBlackInfo: '/whiteblack/delWhiteBlackInfo',
    /** `/whiteblack/queryList` */
    QueryList: '/whiteblack/queryList',
    /** `/whiteblack/searchUserIcCardListInfo` */
    SearchUserIcCardListInfo: '/whiteblack/searchUserIcCardListInfo',
  },
  workermanage: {
    /** `/workermanage/deleteUserWorker` */
    DeleteUserWorker: '/workermanage/deleteUserWorker',
    /** `/workermanage/queryList` */
    QueryList: '/workermanage/queryList',
    /** `/workermanage/queryUserWorker` */
    QueryUserWorker: '/workermanage/queryUserWorker',
    /** `/workermanage/saveUserWorker` */
    SaveUserWorker: '/workermanage/saveUserWorker',
  },
  workingparam: {
    /** `/workingparam/setting` */
    Setting: '/workingparam/setting',
  },
  wxPushLog: {
    /** `/wxPushLog/findById` */
    FindById: '/wxPushLog/findById',
    /** `/wxPushLog/findByParam` */
    FindByParam: '/wxPushLog/findByParam',
  },
} as const

/** 接口总数 */
export const API_COUNT = 540

/* ---------- 高频接口快捷导出（迁移页直接使用） ---------- */
export const COMMON_API = {
  /** 登录 */
  login: '/login',
  /** 退出 */
  logout: '/logout',
  /** 菜单 */
  getMenu: '/getMenu',
  /** 省份下拉 */
  provinces: '/provinces',
  /** 城市下拉 */
  cities: '/cities',
  /** 区县下拉 */
  areas: '/areas',
  /** 商户下拉 */
  traders: '/traders',
  /** 桩下拉 */
  piles: '/piles',
  /** 枪下拉 */
  guns: '/guns',
  /** 文件下载 */
  fileDownload: '/filedownload',
  /** 文件上传 */
  upload: '/upload',
  /** 系统配置 */
  systemConfig: '/getSystemConfig'
} as const
